import ProjectNamespaceListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceListRequest";
import ProjectNamespaceListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceListResponse";
import { NamespaceModel } from "../models";

export const mapGetNamespacesRequest = (projectId: number) =>
  new ProjectNamespaceListRequest({
    ProjectId: projectId,
  });

export const mapGetNamespacesResponse = (response: ProjectNamespaceListResponse) =>
  response.Items.map(
    (namespace) =>
      new NamespaceModel({
        Id: namespace.Id,
        Name: namespace.Name,
        IconId: namespace.IconId,
        IconUrl: namespace.IconUrl,
        ColorId: namespace.ColorId,
        Color: namespace.Color,
        TasksCount: namespace.TaskCount,
        IsAdmin: namespace.IsAdmin
      }),
  );
